// extracted by css-extract-rspack-plugin
export default {"background":"styles-module__background--jmrjk","content":"styles-module__content--xEi6B","bot_image":"styles-module__bot_image--ZqQWA"};